import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OBPPUserAccountSummaryService } from 'src/app/services/account-summary/account-summary.service';
import { OBPPLoginService } from 'src/app/services/login-page/login-page.service';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { OBPPModalDialogComponent } from '../../error-component/modal-dialog/modal-dialog.component';
import { AUPaymentSuccess, ReceiptData } from 'src/app/models/obpp-invoice.model';
import { EMAIL_REGEX } from 'src/app/common/email-validator';
import { InvoiceItem, InvoiceLevelPayNowEvent } from '../obpp-invoice-summary/obpp-invoice-summary.models';

@Component({
  selector: 'app-obpp-invoice-summary-page',
  templateUrl: './obpp-invoice-summary-page.component.html',
  styleUrls: ['./obpp-invoice-summary-page.component.scss'],
})
export class OBPPInvoiceSummaryPageComponent implements OnInit {
  @Input() openedSummaryResponse: any;
  @Input() uname = '';

  isViewOnly = false;
  isUpdateInProgress = true;
  showInvoiceSummary = false;
  showIFrame = false;
  paymentSuccessFlag = false;
  declinedMessage = false;
  isEmailRequired = false;
  notifyEmail = '';
  paymentCurrency = '';

  accountsList: InvoiceItem[] = [];
  selectedInvoiceList: any[] = [];
  invoiceData: InvoiceItem[] = [];
  accountName: any[] = [];

  receiptGeneric!: ReceiptData;
  isMonerisIframeRendered = false;

  constructor(
    private obppLoginService: OBPPLoginService,
    private modalService: NgbModal,
    private dataSharingService: DataSharingService,
    private obppUserAccountSummaryService: OBPPUserAccountSummaryService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.isViewOnly = this.obppLoginService.getIsViewOnly();
    this.dataSharingService.IsLoadingEnabled.next(true);
    this.bootstrapFromResolved(this.openedSummaryResponse);
    this.dataSharingService.IsLoadingEnabled.next(false);
    this.showInvoiceLevelPopup();
  }

  private showInvoiceLevelPopup(): void {
    const modalRef = this.modalService.open(OBPPModalDialogComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'invoice-level-popup-modal',
    });
    modalRef.componentInstance.my_modal_content = 'INVOICE_LEVEL_POPUP_MSG';
    modalRef.componentInstance.firstButtonLabel = 'PROCEED_TEXT';
    modalRef.result.then(() => {
      this.showInvoiceSummary = true;
    });
  }

  private bootstrapFromResolved(res: any): void {
    const accounts = res?.serviceResponse?.object ?? [];
    this.invoiceData = this.setupAccountList(accounts);

    this.accountName = this.invoiceData
      .map((e: any) => [e.accounts.accountName, e.accounts.accountNumber])
      .map((a: any) => JSON.stringify(a))
      .filter((v: string, i: number, arr: string[]) => arr.indexOf(v) === i)
      .map((s: string) => JSON.parse(s))
      .sort();
  }

  setupAccountList(obj: any): InvoiceItem[] {
    let res = this.cloneObject(obj);
    res = res.map((acc: any) =>
      acc.invoices.map((inv: any) => {
        delete acc.invoices;
        inv.accounts = acc;
        inv.paymentAmount = 0;
        inv.payAmount = 0;
        inv.currency = inv.invoiceCurrency;
        return inv;
      })
    );
    res = ([] as any[]).concat(...res);
    return res;
  }

  cloneObject(obj: any) {
    if (!obj) return [];
    return JSON.parse(JSON.stringify(obj));
  }

  onInvoiceLevelPayNow(event: InvoiceLevelPayNowEvent): void {
    this.paymentCurrency = event.currency;
    this.accountsList = event.invoices;
    this.isUpdateInProgress = false;
  }

 
  removeInvoice(invoice: any): void {
    this.accountsList = this.accountsList.filter(
      (inv) => inv.invoiceNumber !== invoice.invoiceNumber
    );
    if (this.accountsList.length === 0) {
      this.goBackSummaryPage();
    }
    this.showIFrame = false;
  }

  goBackSummaryPage(): void {
    this.isUpdateInProgress = true;
    this.showIFrame = false;
    this.declinedMessage = false;
  }

  getCartTotal(): number {
    const total = this.accountsList
      .filter((inv: any) => inv.currency === this.paymentCurrency)
      .reduce((sum: number, inv: any) => sum + (parseFloat(inv.paymentAmount) || 0), 0);
    return parseFloat(total.toFixed(2));
  }

  loadIFrame(): void {
    this.loadMonerisIframe();
  }

  private loadMonerisIframe(): void {
    this.selectedInvoiceList = [];
    this.dataSharingService.IsLoadingEnabled.next(true);

    this.accountsList.forEach((item: any) => {
      this.selectedInvoiceList.push({
        accountName: item.accounts.accountName,
        accountNumber: item.accounts.accountNumber,
        invoiceNumber: item.invoiceNumber,
        invoiceDate: Date.parse(item.invoiceDate),
        dueDate: Date.parse(item.dueDate),
        paymentAmount: item.paymentAmount,
        invoiceAmount: item.invoiceAmount,
        balanceDue: item.balanceDue,
        note: '',
        isChecked: true,
        obppInvoiceShipments: [],
      });
    });

    this.showIFrame = true;
    this.dataSharingService.IsLoadingEnabled.next(false);
  }

  disableRemoveInvoiceHandler(isDisabled: boolean): void {
    this.isMonerisIframeRendered = isDisabled;
  }

  paymentFailureHandler(showIframe: boolean): void {
    this.showIFrame = !showIframe;
    this.declinedMessage = true;
  }

  receiptEmailHandler(alternativeEmail: boolean): any {
    return alternativeEmail ? [true, this.notifyEmail] : [false, ''];
  }

  paymentSuccessHandler(info: AUPaymentSuccess): void {
    if (info) {
      this.showIFrame = info.showIframe;
      this.paymentSuccessFlag = info.paymentSuccessFlag;
    }
    this.receiptGeneric = info.receiptData ? info.receiptData : info.receiptEftData!;
  }

  resetToSummary(): void {
    this.isUpdateInProgress = true;
    this.showIFrame = false;
    this.paymentSuccessFlag = false;
    this.declinedMessage = false;
    this.isEmailRequired = false;
    this.notifyEmail = '';
    this.paymentCurrency = '';
    this.accountsList = [];
    this.selectedInvoiceList = [];
    this.bootstrapFromResolved(this.openedSummaryResponse);
  }

  getInvoicePDF(invoiceNumber: string): void {
    this.dataSharingService.IsLoadingEnabled.next(true);
    this.obppUserAccountSummaryService
      .getInvoicePDF(invoiceNumber)
      .subscribe({
        next: (res: any) => {
          const file = new Blob([res], { type: 'application/pdf' });
          if (file.size > 0) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
          this.dataSharingService.IsLoadingEnabled.next(false);
        },
        error: () => {
          this.openDialog('DOWNLOAD_ERROR', 'PDF_UNAVAILABLE', null, 'OK', 'error');
          this.dataSharingService.IsLoadingEnabled.next(false);
        },
      });
  }

  isValidEmail(emailString: string): boolean {
    try {
      return new RegExp(EMAIL_REGEX).test(emailString);
    } catch {
      return false;
    }
  }

  isButtonDisabled(): boolean {
    return (
      this.isUpdateInProgress ||
      this.isViewOnly ||
      (this.isEmailRequired && !this.isValidEmail(this.notifyEmail)) ||
      this.getCartTotal() === 0
    );
  }

  selectCheckBox(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    (event.target as HTMLInputElement).click();
  }

  printPage(): void {
    const css = '@page { size: landscape; }';
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.media = 'print';
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
    window.print();
  }

  openDialog(title: string, body: string, firstButton: any, secondButton: any, type: string): void {
    const modalRef = this.modalService.open(OBPPModalDialogComponent);
    modalRef.componentInstance.my_modal_title = title;
    modalRef.componentInstance.my_modal_content = body;
    modalRef.componentInstance.firstButtonLabel = firstButton;
    modalRef.componentInstance.secondButtonLabel = secondButton;
    modalRef.componentInstance.modalType = type;
  }
}
